import { Box, Typography } from '@mui/material';
import { kollectAITheme } from 'config/theme';
import useStyles, { Button } from './index.styles';

const CommunicationLogHeader = () => {
  const classes = useStyles();

  return (
    <Box position='relative'>
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <Typography fontSize='1.5rem'>Communication logs</Typography>
      </Box>

      <Box className={classes.headerAbsolute}>
        <button>
          <Typography
            sx={{
              textDecoration: 'underline',
              fontSize: '0.9rem',
              color: kollectAITheme.primaryColor,
              cursor: 'pointer',
            }}
          >
            Export to CSV
          </Typography>
        </button>
        <Button>
          <Typography fontSize='0.9rem'>Re-trigger</Typography>
        </Button>
      </Box>
    </Box>
  );
};
export default CommunicationLogHeader;
